"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRejection = exports.allToResolveOrReject = void 0;
/**
 * The difference between this and `Promise.all` is that `Promise.all` rejects
 * when any promise rejects, and this resolves when all promises resolve _or_
 * reject.
 *
 * This function returns an array of results, each of which is either a success
 * result containing the resolved promise, or an error result containing the
 * value that was passed to `reject()`.
 *
 * This function itself never throws or rejects.
 */
const allToResolveOrReject = (promises) => __awaiter(void 0, void 0, void 0, function* () {
    // Attach a dummy rejection handler to each promise as soon as possible, to
    // try to prevent them from rejecting in the background without a handler, as
    // that can cause issues, depending on the runtime environment.
    //
    promises.forEach(exports.handleRejection); // try to comment this out & run the tests
    const results = [];
    for (const promise of promises) {
        try {
            const value = yield promise;
            results.push({ isSuccess: true, value });
        }
        catch (error) {
            results.push({ isSuccess: false, error });
        }
    }
    return results;
});
exports.allToResolveOrReject = allToResolveOrReject;
/**
 * Attach a dummy rejection handler to a promise and return the original
 * promise. Used to prevent unhandled rejections in the background.
 *
 * To use this, wrap any `async` or `Promise`-returning function with this
 * function and use it as you otherwise would.
 *
 * Calling this multiple times for the same promise should have no ill effect.
 *
 * @example
 * // Before
 * await fetch('https://hevy.com/blabla');
 *
 * // After
 * await handleRejection(fetch('https://hevy.com/blabla'));
 */
const handleRejection = (p) => (p.catch(() => { }), p);
exports.handleRejection = handleRejection;
